import DatePicker from '@common/components/DatePicker.vue';
import DecoratedModal from '@common/components/DecoratedModal.vue';
import DetailsCard from '@common/components/DetailsCard.vue';
import DetailsCardItem from '@common/components/DetailsCardItem.vue';
import DetailsCardLink from '@common/components/DetailsCardLink.vue';
import DropDown from '@common/components/DropDown.vue';
import FdxBadge from '@common/components/FdxBadge.vue';
import Breadcrumb from '@common/components/FdxBreadcrumb.vue';
import Modal from '@common/components/FdxModal.vue';
import FormBox from '@common/components/FormBox.vue';
import FormItem from '@common/components/FormItem.vue';
import FormModal from '@common/components/FormModal.vue';
import Checkbox from '@common/components/LegacyCheckbox.vue';
import Tooltip from '@common/components/LegacyTooltip.vue';
import ListingScreen from '@common/components/ListingScreen.vue';
import MonthRange from '@common/components/MonthRange.vue';
import ScreenLoader from '@common/components/ScreenLoader.vue';
import SelectInput from '@common/components/SelectInput.vue';
import { defineAsyncComponent } from 'vue';

const deferredComponents = {
  ActivationButton: defineAsyncComponent(() => import('@common/components/ActivationButton.vue')),
  BadgesCard: defineAsyncComponent(() => import('@common/components/BadgesCard.vue')),
  BadgesList: defineAsyncComponent(() => import('@common/components/BadgesList.vue')),
  ConfirmButton: defineAsyncComponent(() => import('@common/components/ConfirmButton.vue')),
  DeleteButton: defineAsyncComponent(() => import('@common/components/DeleteButton.vue')),
  DetailsCardCompare: defineAsyncComponent(
    () => import('@common/components/DetailsCardCompare.vue')
  ),
  ErrorMessages: defineAsyncComponent(() => import('@common/components/ErrorMessages.vue')),
  FdxLink: defineAsyncComponent(() => import('@common/components/FdxLink.vue')),
  FiltersChips: defineAsyncComponent(() => import('@common/components/FiltersChips.vue')),
  FullScreenToggle: defineAsyncComponent(() => import('@common/components/FullScreenToggle.vue')),
  HelpCenterLink: defineAsyncComponent(() => import('@common/components/HelpCenterLink.vue')),
  ImportExportAction: defineAsyncComponent(
    () => import('@common/components/ImportExportAction.vue')
  ),
  NewTooltip: defineAsyncComponent(() => import('@common/components/NewTooltip.vue')),
  PhoneNumber: defineAsyncComponent(() => import('@common/components/PhoneNumber.vue')),
  RestoreButton: defineAsyncComponent(() => import('@common/components/RestoreButton.vue')),
  Search: defineAsyncComponent(() => import('@common/components/SearchInput.vue')),
  TableCard: defineAsyncComponent(() => import('@common/components/TableCard.vue')),
};

const eagerComponents = {
  Breadcrumb,
  Checkbox,
  DatePicker,
  DecoratedModal,
  DetailsCard,
  DetailsCardItem,
  DetailsCardLink,
  DropDown,
  FdxBadge,
  FormBox,
  FormItem,
  FormModal,
  ListingScreen,
  Modal,
  MonthRange,
  ScreenLoader,
  SelectInput,
  Tooltip,
};

export default {
  ...deferredComponents,
  ...eagerComponents,
};
